import color from '../../text/color';

const light = (params) => color(params);

export default light;
